// @ts-nocheck
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import TSPSDK from '@shopee/tsp-sdk'
import type { I18nKey, I18nT } from '@/types/i18n'
import en from '@/assets/strings/i18n/en.json'
import id from '@/assets/strings/i18n/id.json'
import msMy from '@/assets/strings/i18n/ms-my.json'
import zhHans from '@/assets/strings/i18n/zh-Hans.json'
import th from '@/assets/strings/i18n/th.json'
import vi from '@/assets/strings/i18n/vi.json'
import ph from '@/assets/strings/i18n/ph.json'
import enPh from '@/assets/strings/i18n/en-ph.json'
import { AppCountry, AppEnvironment, AppLanguage } from '@/constants/app.constant'
import { Language } from '@/constants/env.constant'

const UTM_COLLECTION_ID = 2087
const UTM_CDN_PATH = 'shopeefood-partner-web'

const utmLocaleMap: Record<Language, string> = {
  [Language.en]: 'en',
  [Language.id]: 'id',
  [Language['ms-my']]: 'ms-my',
  [Language['zh-Hans']]: 'zh-Hans',
  [Language.th]: 'th',
  [Language.ph]: 'ph',
  [Language['en-ph']]: 'en-ph',
  [Language.vi]: 'vi',
}

const utmTranslator = new TSPSDK({
  name: 'merchant-web',
  defaultCdnPath: UTM_CDN_PATH,
})

// 每个国家对应的语言 - MS
// const transifyFileMap = {
//   id: ['en', 'id'],
//   my: ['en', 'ms', 'zh-my'],
//   ph: ['en', 'ph', 'zh-Hans'],
//   sg: ['en', 'zh-Hans'],
//   th: ['en', 'th'],
//   vn: ['en', 'vi'],
// }

const resources: Record<Language, any> = {
  [Language.en]: {
    translation: en,
  },
  [Language.id]: {
    translation: id,
  },
  [Language['ms-my']]: {
    translation: msMy,
  },
  [Language['zh-Hans']]: {
    translation: zhHans,
  },
  [Language.th]: {
    translation: th,
  },
  [Language.ph]: {
    translation: ph,
  },
  [Language['en-ph']]: {
    translation: enPh,
  },
  [Language.vi]: {
    translation: vi,
  },
}

export const initLanguage = async (language: Language) => {
  AppLanguage.current = language

  await i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: Language.en,
    interpolation: {
      prefix: '{',
      suffix: '}',
    },
  })

  try {
    const { translation } = await utmTranslator.create({
      env: AppEnvironment.isLive ? 'live' : 'nonlive',
      locale: utmLocaleMap[language],
      translation: {
        utmCollections: [UTM_COLLECTION_ID],
      },
    })

    if (translation && Object.keys(translation).length > 0) {
      // UTM 文案覆盖本地 Transify 文案；UTM 请求失败时仍使用本地资源兜底。
      i18n.addResourceBundle(language, 'translation', translation, true, true)
    }
  } catch (error) {
    console.error('[i18n] Failed to load UTM translations', error)
  }
}

const origionT = i18n.t.bind(i18n)
function i18nT(key: I18nKey, options?: any) {
  const suffixKey = `${key}__${AppCountry.current.toUpperCase()}`
  const hasSuffix = i18n.exists(suffixKey)

  if (hasSuffix) {
    return origionT(suffixKey, options)
  }

  return origionT(key, options)
}

export const t = i18nT as I18nT

/**
 * Mart 翻译
 * @param key 国际化 key
 * @param options
 * @returns
 */
export function tMart(key: I18nKey, options?: any) {
  if (AppCountry.isVn && window.isMartStore) {
    const result = t(`mart.${key}` as any, options)
    if (result === `mart.${key}`) {
      return t(key as any, options)
    }
    return result
  }

  return t(key as any, options)
}

export default i18n
